import { styled as t, Box as x, Button as I, Typography as S } from "@mui/material";
import T from "../../../assets/icons/icon-left-arrow.svg.js";
import B from "../../../assets/icons/icon-right-arrow.svg.js";
import k from "./TextInput.js";
import h from "../next/Image.js";
import * as V from "ramda";
import { useState as A, useCallback as s, useEffect as D } from "react";
import { useTranslation as E } from "react-i18next";
import { jsxs as M, jsx as e, Fragment as j } from "react/jsx-runtime";
const L = t(x)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`, b = t(I)`
  width: 65px;
  height: 35px;
  border-radius: 3px;
  background-color: #252728;
  :hover {
    background-color: #535556;
  }
  :disabled {
    background-color: #151615;
  }
`, R = t(b)`
  margin-right: 26px;
`, z = t(b)`
  margin-left: 26px;
`, F = t(h)`
  height: 100%;
  width: 100%;
  ${(o) => o.disabled ? "filter: opacity(0.3)" : "filter: opacity(1)"};
`, G = t(h)`
  height: 100%;
  width: 100%;
  ${(o) => o.disabled ? "filter: opacity(0.3)" : "filter: opacity(1)"};
`, $ = t(x)`
  display: flex;
  width: 65px;
  height: 35px;
  background-color: #151615;
  border-radius: 3px;
`, H = t(k)`
  background-color: #151615;
  color: #ffffff;

  & .MuiOutlinedInput-input {
    font-size: 16px;
    margin-top: 2px;
    text-align: center;
  }
`, P = t(S)`
  color: #ffffff;
  font-size: 16px;
`, O = t(P)`
  margin-right: 22px;
`, _ = t(P)`
  margin-left: 18px;
  white-space: nowrap;
`, q = (o, a) => Number.isInteger(o) && o > 0 && (a != null ? o <= a : !0), tt = (o) => {
  const {
    className: a,
    nextDisabled: p = !1,
    prevDisabled: d = !1,
    totalPage: i,
    value: r,
    onNext: N,
    onPrev: w,
    onSubmit: c
  } = o, {
    t: f
  } = E(), [u, m] = A(r.toString()), y = s((n) => {
    m(n.target.value);
  }, []), l = s(() => {
    const n = Math.round(Number(u));
    if (isNaN(n) || !q(n, i)) {
      m(r.toString());
      return;
    }
    c && n !== r && c(n);
  }, [c, u, i, r]), v = s(() => {
    l();
  }, [l]), C = s((n) => {
    n.preventDefault();
    const g = n.currentTarget.ownerDocument.activeElement;
    g instanceof HTMLElement && g.blur(), l();
  }, [l]);
  return D(() => {
    m(r.toString());
  }, [r]), /* @__PURE__ */ M(L, {
    className: a,
    children: [/* @__PURE__ */ e(R, {
      className: "Custom-Page-Button",
      disabled: d,
      onClick: w,
      children: /* @__PURE__ */ e(F, {
        src: T,
        disabled: d
      })
    }), /* @__PURE__ */ e(O, {
      children: f("common.pagination.page")
    }), /* @__PURE__ */ e($, {
      children: /* @__PURE__ */ e("form", {
        onSubmit: C,
        children: /* @__PURE__ */ e(H, {
          className: "Custom-Page-Input",
          value: u,
          onChange: y,
          onBlur: v,
          type: "text",
          inputProps: {
            inputMode: "numeric",
            pattern: "[0-9]*",
            "aria-label": "page number input"
          }
        })
      })
    }), !V.isNil(i) && i > 0 ? /* @__PURE__ */ e(_, {
      children: f("common.total_page", {
        totalPageNumber: i
      })
    }) : /* @__PURE__ */ e(j, {}), /* @__PURE__ */ e(z, {
      className: "Custom-Page-Button",
      disabled: p,
      onClick: N,
      children: /* @__PURE__ */ e(G, {
        src: B,
        disabled: p
      })
    })]
  });
};
export {
  tt as default
};
//# sourceMappingURL=Pagination.js.map
